module.exports = __webpack_public_path__ + "static/img/fang.98140b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/fang.jpg
// module id = KhJd
// module chunks = 21